import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../context/LanguageContext';
import SEO from '../components/SEO';
import { PAGE_SEO } from '../utils/pageSeo';
const intelligenceImg = '/Images/bg-intelligence.jpg';
const dataCenterImg = '/Images/bg-data-center.jpg';
const commandCenterImg = '/Images/bg-command-center.jpg';
const customAiSystemsImg = '/Images/custom-ai-system.jpg';

const Capabilities = () => {
  const { t } = useTranslation('capabilities');
  const { language } = useLanguage();
  const seo = PAGE_SEO.capabilities;

  const capabilities = [
    {
      title: t('cards.predictive.title'),
      description: t('cards.predictive.description'),
      tag: t('cards.predictive.tag'),
      image: commandCenterImg,
      isLarge: true,
      isExtraLarge: true,
      imageRight: true
    },
    {
      title: t('cards.custom.title'),
      description: t('cards.custom.description'),
      tag: t('cards.custom.tag'),
      image: customAiSystemsImg,
      isLarge: true,
      isExtraLarge: true
    },
    {
      title: t('cards.integration.title'),
      description: t('cards.integration.description'),
      tag: t('cards.integration.tag')
    },
    {
      title: t('cards.workflow.title'),
      description: t('cards.workflow.description'),
      tag: t('cards.workflow.tag')
    },
    {
      title: t('cards.advisory.title'),
      description: t('cards.advisory.description'),
      tag: t('cards.advisory.tag')
    },
    {
      title: t('cards.sovereign.title'),
      description: t('cards.sovereign.description'),
      tag: t('cards.sovereign.tag'),
      image: dataCenterImg,
      isLarge: true,
      isExtraLarge: true,
      imageRight: true
    }
  ];

  return (
    <div className="capabilities-page">
      <SEO 
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        canonicalPath={`/${language}/capabilities`}
      />
      {/* Hero Section */}
      <section className="hero-section capabilities-hero">
        <div className="hero-background">
          <div className="gradient-layer"></div>
          <div className="particle-layer"></div>
          <div className="grid-overlay"></div>
          <div className="tech-lines"></div>
        </div>
        
        <div className="hero-content">
          <div className="container">
            <div className="hero-wrapper">
              {/* Tech decorative elements */}
              <div className="tech-element tech-element-1"></div>
              <div className="tech-element tech-element-4"></div>
              <div className="tech-element tech-element-7"></div>
              
              <h1 className="hero-quote">
                <span className="quote-highlight">{t('hero.title')}</span><br />
                {t('hero.subtitle1')}<br />
                {t('hero.subtitle2')}
              </h1>
              <p className="hero-subtitle fade-in" style={{ animationDelay: '0.2s' }}>
                {t('hero.description')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Capabilities Content */}
      <section className="capabilities-grid-section mb-5 pb-5">
        <div className="container">
          <div className="row g-4">
            {capabilities.map((capability, index) => {
              const colClass = capability.isExtraLarge ? 'col-12' : capability.isLarge ? 'col-lg-12 col-xl-8' : 'col-lg-6 col-xl-4';
              return (
                <div key={index} className={colClass}>
                  <div className={`capability-card-modern fade-in ${capability.title === t('cards.custom.title') ? 'highlighted-card' : ''} ${capability.isLarge ? 'capability-card-large' : ''} ${capability.imageRight ? 'image-right' : ''}`} style={{ animationDelay: `${0.3 + index * 0.1}s` }}>
                    {capability.image && !capability.imageRight && (
                      <div className="capability-card-image">
                        <img src={capability.image} alt={capability.title} />
                        <div className="ai-generated-overlay">AI-Generated</div>
                      </div>
                    )}
                    {capability.isLarge ? (
                      <div className="capability-card-content">
                        <div className="card-tag">{capability.tag}</div>
                        <h2 className="capability-title-bold">{capability.title}</h2>
                        <div className="card-divider"></div>
                        <p className="capability-desc-text">{capability.description}</p>
                      </div>
                    ) : (
                      <>
                        <div className="card-tag">{capability.tag}</div>
                        <h2 className="capability-title-bold">{capability.title}</h2>
                        <div className="card-divider"></div>
                        <p className="capability-desc-text">{capability.description}</p>
                      </>
                    )}
                    {capability.image && capability.imageRight && (
                      <div className="capability-card-image">
                        <img src={capability.image} alt={capability.title} />
                        <div className="ai-generated-overlay">AI-Generated</div>
                      </div>
                    )}
                    <div className="card-footer-decoration"></div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Capabilities;
